import * as React from 'react'
import { MdAccessTime as AccessTime } from '@react-icons/all-files/md/MdAccessTime'
import { Link } from 'react-router-dom'
import mixpanel from '@disco/api/mixpanel'
import { getTrialLeft } from '@disco/utils/trial'
import classNames from 'clsx'
import styles from './index.module.css'

type Props = {
  trialEnd: number
}
export default class HeaderTrialNotification extends React.Component<Props> {
  _onClick: () => void = () =>
    mixpanel.sendPureEvent('Open Billing via trial prompt (user click)')

  render(): React.ReactElement<'div'> {
    const { message } = getTrialLeft(this.props.trialEnd, 'short')
    return (
      <div className={classNames('flc', styles.headerTrialNotification)}>
        <AccessTime size={24} />
        <div className={styles.headerTrialNotificationMessage}>{message}</div>
        <Link to="/settings/billing" onClick={this._onClick}>
          Buy now!
        </Link>
      </div>
    )
  }
}
